import { useWorkflows } from './useWorkflows';

/**
 * One workflow of a workspace, addressed by its key — the identity the URL
 * carries (`$workflowKey`), unique per workspace by contract.
 *
 * `workflow` is `undefined` in three distinguishable situations the caller
 * must keep apart: while `isPending`, when `loadFailed`, and — only after a
 * completed read — when the key names nothing, which is the route's not-found
 * condition (research R10).
 */
export function useWorkflow(workspaceId: string, workflowKey: string) {
  const { workflows, isPending, loadFailed, refetch } =
    useWorkflows(workspaceId);
  return {
    workflow: workflows.find((workflow) => workflow.key === workflowKey),
    isPending,
    loadFailed,
    refetch,
  };
}
